// @flow

import styled  from 'styled-components';

export const Body = styled.div`
  line-height: 1.5;
`;

export const Content = styled.section`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 0 16px 32px 16px;
  font-family: ${props => props.theme.fontFamily.sansSerif};

  > * {
    width: 100%;
    margin: 16px auto 6px;
  }

  @media (min-width: 840px) {
    height: auto;
    padding: 0 32px 16px 32px;
  }
`;

export const PaymentInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border: 1px solid rgb(220, 225, 230);
  border-radius: 5px;
`;

export const PaymentInfoContainer = styled.div`
  margin-top: 1em;
  background-color: ${props => props.bgColor ? props.bgColor: '#fff'};
  border: solid 1px rgb(220,225,230);
  border-radius: 0.3em;
`;

export const PaymentInfoInnerContainer = styled.div`
  display: flex;
  padding: 1.1em;
  color: #333333;
  text-align: left;
`;

export const PaymentInfoIcon = styled.div`
  width: 20%;
`;

export const PaymentInfoText = styled.div`
  width: 80%;
`;

export const NoStyleDiv = styled.div`
  border: 0;
`;

export const HeaderText = styled.div`
  font-weight: 800;
`;

export const DataBox = styled.div`
  border-top: 1px solid rgb(220, 225, 230);
  flex: 100%;
  min-height: 200px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &:empty {
    display: none;
  }
`;

export const DashedHr = styled.hr`
  display: block; height: 1px;
  border: 0;
  border-top: 1px dashed rgb(197, 197, 197);
  margin: 1.6em 0; padding: 0;
`;

export const H1 = styled.h1`
  margin-top: 1em;
  font-size: 1.1em;
  text-align: center;
`;

export const InstructionsContainer = styled.div`
  margin-top: 1em;
  display: flex;
  flex-direction: column;
`;


export const SingleInstructionWrapperDiv = styled.div`
  margin-top:1em;
`;

export const CircleBgDiv = styled.div`
  background: #e3e3e3;
  padding: 0.25em;
  border-radius: 50%;
  display: block;
  width: 2em;
  height: 2em;
  float: left;
`;

export const SingleInstructionDiv = styled.div`
  text-align:left;
  margin-left:3em;
  display: flex;
  margin-bottom: 1em;
`;
